export const global = {
    endpoint_api: window.location.hostname === "localhost" ? "http://localhost:3300/public_api/v1" : "https://api.exhibition.sytin-museum.ru/public_api/v1"
}